import React from "react";

const SortIcon: React.FC<{ sortOrder: string | null }> = ({ sortOrder }) => {
    // Always render a span so layout doesn't shift; rotate via .desc class for descending
    const className = sortOrder === 'desc' ? 'desc' : '';
    return <span className={className} />;
};

export default SortIcon;